export const sendOtp = () =>
    (`/api/user/otp`);
export const verifyOtp = () =>
    (`/api/user/otp-verify`);